/* eslint-disable no-continue */
import { API } from 'aws-amplify';

import { tenantsByFacility } from '../../graphql/queries';
import { User } from '../model/types';

// Helper function to turn all the fetched tenants into the admin app-specific User type
const appsyncTenantsToUserType = (fetchedTenants: any[]): User[] => {
    // Convert all the tenant info into the app-specific User type by removing all the optional / null / undefined values
    const users: User[] = []
    console.log('Fetched tenants length: ', fetchedTenants.length)
    for (let i = 0; i < fetchedTenants.length; i+=1) {
        const tenant = fetchedTenants[i]
        if (!tenant) {
            console.warn('Found null tenant in appsync tenantsByFacility response.')
            continue;
        }
        // Thanks Appsync...thanks a lot for the optionals!!
        // TODO(typing): should our data really be this optional...
        if (!tenant.id || !tenant.facilityID || !tenant.name || !tenant.email || !tenant.phone ||
            !tenant.address || !tenant.address.addressLine1 || !tenant.address.city || !tenant.address.state || !tenant.address.zip ||
            !tenant.plan || !tenant.plan.minStay || !tenant.plan.typeOfPlan || !tenant.plan.size || !tenant.plan.price) {
            console.warn('Found tenant with missing data. Will skip instead of processing...')
            continue;
        }
        users.push({
            id: tenant.id,
            facilityID: tenant.facilityID,
            name: tenant.name,
            email: tenant.email,
            phone: tenant.phone,
            address: {
                addressLine1: tenant.address.addressLine1,
                addressLine2: tenant.address.addressLine2 ?? '',
                city: tenant.address.city,
                state: tenant.address.state,
                zip: tenant.address.zip,
                specialInstructions: tenant.address.specialInstructions ?? '',
                building: tenant.address.building ?? '',
                parking: tenant.address.parking ?? '' 
            },
            unitID: tenant.unitID ?? '',
            // sitelinkTenantID: tenant.tenantID,
            // accessCode: tenant.accessCode,
            plan: {
                minStay: tenant.plan.minStay,
                typeOfPlan: tenant.plan.typeOfPlan,
                size: tenant.plan.size,
                price: tenant.plan.price,
            }
        });
    }
    console.log(`Processed all fetched tenants from appsync. Found ${users.length} tenants.`)
    return users;
}

export const GetTenants = async (facilityID: string): Promise<User[]> => {
    // tenantsByFacility is a GSI query (not a filtered scan), so a high limit
    // returns every tenant in one page instead of silently capping at ~100.
    const result = await API.graphql({
        query: tenantsByFacility,
        variables: { facilityID, limit: 10000 },
    }) as any;
    const items = result?.data?.tenantsByFacility?.items ?? [];
    return appsyncTenantsToUserType(items)
};
